import { Box, VStack } from "@chakra-ui/react";
import { colors, HLine, Spacing } from "goi_common";
import { ReactNode } from "react";

interface OptionCardProps {
  title: ReactNode;
  subtitle: ReactNode;
  description: ReactNode;
  benefitText: ReactNode;
  benefitHighlight?: boolean;
  isHighlighted?: boolean;
  highlightLabel?: string;
  actionButton?: ReactNode;
}

/**
 * OptionCard - 선택 옵션을 표시하는 카드 컴포넌트
 *
 * UI 요소로서 비즈니스 로직과 분리되어 있습니다.
 * 결제 옵션, 상품 옵션 등 다양한 선택지를 표시할 때 사용할 수 있습니다.
 */
export const OptionCard = ({
  title,
  subtitle,
  description,
  benefitText,
  benefitHighlight = false,
  isHighlighted = false,
  highlightLabel = "인기",
  actionButton,
}: OptionCardProps) => {
  return (
    <VStack
      position="relative"
      flex={1}
      border={
        isHighlighted
          ? `2px solid ${colors.orange650}`
          : `1px solid ${colors.gray200}`
      }
      borderRadius="6px"
      padding="16px"
      alignItems="flex-start"
      gap={0}
    >
      {isHighlighted && (
        <Box
          position="absolute"
          top="-9px"
          left="8px"
          backgroundColor={colors.orange650}
          color={colors.white}
          padding="2px 6px"
          borderRadius="999px"
          className="caption_11_sb"
        >
          {highlightLabel}
        </Box>
      )}
      <VStack width="100%" alignItems="flex-start" gap={0}>
        <Box className="subtitle_16_sb gray900">{title}</Box>
        <Box className="subtitle_16_sb gray900">{subtitle}</Box>
      </VStack>

      <Spacing gap={32} />
      <Box className="body_14_r gray700">{description}</Box>

      <Spacing gap={12} />
      <HLine color={colors.gray100} height={1} style={{ width: "100%" }} />

      <Spacing gap={12} />
      <Box
        className={benefitHighlight ? "subtitle_14_sb" : "body_14_r gray700"}
        color={benefitHighlight ? colors.orange650 : colors.gray700}
      >
        {benefitText}
      </Box>

      {actionButton && (
        <>
          <Spacing gap={16} />
          <Box width="100%">{actionButton}</Box>
        </>
      )}
    </VStack>
  );
};
